module.exports = __webpack_public_path__ + "img/motorcycle-panel.cd802825.png";